// extracted by mini-css-extract-plugin
export default {"greenText":"_3427aa9e"};